var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table',{attrs:{"columns":_vm.columns,"resource":_vm.resource,"filters":_vm.filters}})}
var staticRenderFns = []

export { render, staticRenderFns }